export type PublicProfileRow = {
  id: string;
  handle: string | null;
  display_name: string | null;
  avatar_url: string | null;
  gym_id: string | null;
  trainer_user_id: string | null;
  visibility: 'public' | 'gym_only' | 'private' | null;
};

export function handleToUsername(handle: string | null): string | null {
  return handle ?? null;
}
